module.exports = __webpack_public_path__ + "img/main_menu_2.fea2c2c1.png";